"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legal = void 0;
const axios_class_1 = require("./axios.class");
class Legal {
    getLastLegalsAccepted() {
        return axios_class_1.axios.get(`/legals/lastLegalsAccepted`);
    }
    acceptTermsAndConditions() {
        return axios_class_1.axios.post(`/legals/accept/termsAndConditions`);
    }
    acceptPrivacyPolicy() {
        return axios_class_1.axios.post(`/legals/accept/privacyPolicy`);
    }
    // deprecated
    getPrivacyPolicy(application) {
        return axios_class_1.axios.get(`/v1/legals/privacyPolicy${application}`);
    }
    getPrivacyPolicyV2(application) {
        return axios_class_1.axios.get(`/v1/legals/type/privacyPolicy${application}`);
    }
    // deprecated
    getTermsAndConditions(application) {
        return axios_class_1.axios.get(`/v1/legals/termsAndConditions${application}`);
    }
    getTermsAndConditionsV2(application) {
        return axios_class_1.axios.get(`/v1/legals/type/termsAndConditions${application}`);
    }
    // get specific client legal defined in client settings
    getLegalsById(legalsId) {
        return axios_class_1.axios.get(`/v2/legals/${legalsId}`);
    }
    async lastLegalsAccepted() {
        const { data } = await axios_class_1.axios.get('/legals/lastLegalsAccepted');
        return data;
    }
    accept() {
        return axios_class_1.axios.post('/legals/accept');
    }
}
exports.legal = new Legal();
